import React, { useCallback, useEffect } from "react"
import { useNavigate, useLocation, Outlet } from "react-router-dom"
import DSTab from "ui/DSTab"
import { useTranslation } from "react-i18next"
import { routes } from "router/routes"
import { usePermissions } from "hooks/usePermissions"
import { MODULES, ACTIONS } from "utils/permissions"
import tabStyles from "./index.module.css"

const ResourcesContainer = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const { hasPermission } = usePermissions()

  useEffect(() => {
    if (location.pathname === routes.guideResourcesPath()) {
      const hasEquipmentViewPermission = hasPermission(MODULES.EQUIPMENT, ACTIONS.VIEW)

      if (hasEquipmentViewPermission) {
        navigate(routes.guideResourcesEquipmentPath(), { replace: true })
      } else {
        navigate(routes.guideResourcesCrewPath(), { replace: true })
      }
    }
  }, [location.pathname, hasPermission, navigate])

  const activeTab = location.pathname.includes("/resources/crew") ? "crew" : "equipment"

  const handleTabChange = useCallback(
    (tab) => {
      if (tab === "equipment") {
        navigate(routes.guideResourcesEquipmentPath())
      } else if (tab === "crew") {
        navigate(routes.guideResourcesCrewPath())
      }
    },
    [navigate]
  )

  const tabItems = [
    hasPermission(MODULES.EQUIPMENT, ACTIONS.VIEW) && {
      key: "equipment",
      label: t("resources.equipment")
    },
    {
      key: "crew",
      label: t("resources.crew")
    }
  ].filter(Boolean)

  return (
    <>
      <DSTab items={tabItems} activeKey={activeTab} onChange={handleTabChange} className={tabStyles.tabs} />
      <Outlet />
    </>
  )
}

export default React.memo(ResourcesContainer)
